import ExcelJS from "exceljs";
export const fintechFunction = async (rule, groupedData) => {
  const wb = new ExcelJS.Workbook(); // Create a new workbook

  // const groupedData = useOutputOf?.output;
  // Testing for Fin-tech
  const filterBasedOnCurrencies = (groupedData, key, currency) => {
    const result = {};
    for (const entry in groupedData) {
      const parts = entry.split("*"); // Split key by '*'
      if (parts[0] === key && parts[2] === currency) {
        result[entry] = groupedData[entry]; // Keep only matching entries
      }
      // Channel and currency are the 2nd and 3rd parts of the key
    }
    return result;
  };
  const insertRecord = ({
    outputSheet,
    currentRule,
    description,
    account,
    debit,
    credit,
  }) => {
    // Insert the first row (Main Transaction)
    outputSheet.addRow({
      description: description,
      account: account,
      debit: debit,
      credit: credit,
    });

    // Insert the second row (Secondary Description) to balance the transaction
    outputSheet.addRow({
      description: currentRule.secondary.description, // e.g "Amt received from Cardholders"
      account: currentRule.secondary.account, // e.g "23001 Cardholder Balances:Cardholder Balance - SGD"
      debit: credit, // Inverse of main entry
      credit: debit, // Inverse of main entry
    });
  };

  Object.keys(rule?.finTech).forEach((ruleKey) => {
    const currentRule = rule?.finTech[ruleKey];
    const key = currentRule?.key; // e.g., "Deposit"
    rule.currency.forEach((currency) => {
      const filteredData = filterBasedOnCurrencies(groupedData, key, currency);

      let outputSheet = wb.addWorksheet(`${key}-${currency}`); // Create a new sheet with a dynamic name
      // Iterate over each filtered data entry
      Object.keys(filteredData).forEach((key) => {
        const row = filteredData[key]; // Extract row data
        const description = row[currentRule.description]; // Get description from row
        const account = currentRule.account; // Get account from rule

        const positiveSum = Math.abs(row.positiveSum); // Ensure positive value
        const negativeSum = Math.abs(row.negativeSum); // Ensure positive value

        const debit = positiveSum > 0 ? positiveSum : "";
        const credit = negativeSum > 0 ? negativeSum : "";
        outputSheet.columns = [
          { header: "Description", key: "description", width: 30 },
          { header: "Account", key: "account", width: 30 },
          { header: "Debit", key: "debit", width: 15 },
          { header: "Credit", key: "credit", width: 15 },
        ];

        // if we have both positive and negative values, we need to split the transaction for negative and positive values respectively
        if (positiveSum > 0 && negativeSum > 0) {
          insertRecord({
            outputSheet,
            currentRule,
            description: `${description} (Greater than 0)`,
            account,
            debit,
            credit: "",
          });
          insertRecord({
            outputSheet,
            currentRule,
            description: `${description} (Less than 0)`,
            account,
            debit: "",
            credit,
          });
          // else have to insert the transaction as is with the positive or negative value and the description along with balancing the transaction
        } else {
          insertRecord({
            outputSheet,
            currentRule,
            description,
            account,
            debit,
            credit,
          });
        }
      });
    });
  });
  const buffer = await wb.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "output.xlsx";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
